<template>
    <div class="catalog-layout">
        <apartments-filters :filters="filters" @submited="onSubmit" @reset="onReset" v-if="parentShowfilter === 'true'"></apartments-filters>
        <div class="catalog-layout__content">
            <div class="catalog-layout__content_head">
                <a :href="parentUrl" class="button-back" v-if="parentUrl">назад</a>
                <h1>Квартиры в ЖК «{{parentTitle}}»</h1>
                <transition name="fade" duration="300">
                    <div class="numbers" v-if="sums.apartmentsTypesCount > 0 & sums.apartmentsCount > 0">
                        <div class="col">
                            <span>{{sums.apartmentsTypesCount}}</span>
                            <small>{{sums.apartmentsTypesCount | typesCount(true)}} <br />квартир</small>
                        </div>
                        <div class="col">
                            <span>{{sums.apartmentsCount}}</span>
                            <small>
                                {{ sums.apartmentsCount | apartmentsCount(true) }} в&nbsp;продаже
                            </small>
                        </div>
                    </div>
                </transition>
            </div>
            <transition name="fade" duration="350">
                <div class="catalog-layout__content_empty" v-if="apartments.list.length == 0">
                    <p>Нет результатов</p>
                </div>
            </transition>
            <div class="catalog-apartments-list">
                <div class="catalog-apartments-list__head trow">
                    <div class="tcol">
                        <span>Планировка</span>
                    </div>
                    <div class="tcol">
                        <apartments-order-button title="Тип" property="rooms" @orderByChanged="onOrderByChanged"></apartments-order-button>
                    </div>
                    <div class="tcol">
                        <apartments-order-button title="Площадь" sign="м<sup>2</sup>" property="square" @orderByChanged="onOrderByChanged"></apartments-order-button>
                    </div>
                    <div class="tcol">
                        <apartments-order-button title="Корпус" property="section" @orderByChanged="onOrderByChanged"></apartments-order-button>
                    </div>
                    <div class="tcol">
                        <apartments-order-button title="Этаж" property="floor" @orderByChanged="onOrderByChanged"></apartments-order-button>
                    </div>
                    <div class="tcol">
                        <apartments-order-button title="Стоимость" sign="₽" property="price" @orderByChanged="onOrderByChanged"></apartments-order-button>
                    </div>
                    <div class="tcol"></div>
                </div>
                <div class="catalog-apartments-list__container">
                    <transition-group name="fade" duration="350" tag="div">
                        <div class="catalog-apartments-list__item trow" v-for="item in apartments.list" :key="item.url">
                            <div class="tcol">
                                <div class="img">
                                    <img :src="planUrl(item.plan)" alt="">
                                </div>
                            </div>
                            <div class="tcol">
                                <span class="lbl">Тип:</span>
                                <span>{{item.rooms | roomsCount}}</span>
                            </div>
                            <div class="tcol">
                                <span class="lbl">Площадь:</span>
                                <span>
                                    {{item.square | threeDigits(2)}} <em>м<sup>2</sup></em>
                                    <small v-if="item.balcony">Балкон</small>
                                    <small v-if="item.terrace">Терраса</small>
                                </span>
                            </div>
                            <div class="tcol">
                                <span class="lbl">Корпус:</span>
                                <span>{{item.section}}</span>
                            </div>
                            <div class="tcol">
                                <span class="lbl">Этаж:</span>
                                <span>{{item.floor}}</span>
                            </div>
                            <div class="tcol">
                                <span class="lbl">Стоимость:</span>
                                <span v-if="item.price > '0'">{{ item.price | threeDigits }} <em><i class="ruble"></i></em></span>
                                <span v-else>Уточнить</span>

                            </div>
                            <div class="tcol">
                                <a :href="parentBaseurl+'apartament/'+item.id+'/'" class="button-pill lighted inline" v-if="parentLanding === 'true'">Подробнее</a>
                                <a :href="item.url" class="button-pill lighted inline" v-if="parentLanding === 'false'">Подробнее</a>
                            </div>
                        </div>
                    </transition-group>
                </div>
                <transition name="fade" duration="250">
                    <div class="catalog-apartments-list__foot" v-if="apartments.list.length < apartments.total">
                        <button class="button-pill inline" @click="getNextPage()" :class="{'loading': apartments.isLoading}">Загрузить ещё</button>
                    </div>
                </transition>
            </div>
        </div>
        <transition name="fade" duration="350">
            <div class="page-spinner show" v-if="apartments.isLoading">
                <span style="background-image: url(/images/logo-blue.svg);"></span>
            </div>
        </transition>
    </div>
</template>

<script>
    // Libs
    import axios from 'axios';
    import qs from 'qs';

    // Components
    import apartmentsFilters from './ApartmentsFilters.vue';
    import apartmentsOrderButton from './ApartmentsOrderButton.vue';
    import VueRouter from 'vue-router';
    
    // Filters
    import threeDigits from '../filters/threeDigits';
    import roomsCount from '../filters/roomsCount';
    import typesCount from '../filters/typesCount';
    import apartmentsCount from '../filters/apartmentsCount';

    // helpers
    import cleanObject from './cleanObject';

    export default {
        props: {
            parent: {
                type: Number,
                required: true
            },
            size: {
                type: Number,
                default: 8
            },
            parentUrl: {
                type: String
            },
            parentTitle: {
                type: String,
                required: true
            },
            parentShowfilter: {
                type: Boolean
            },
            parentLanding: {
                type: Boolean
            },
            parentBaseurl: {
                type: String
            },
            parentLandingid: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                apartments: {
                    list: [],
                    total: 0,
                    page: 0,
                    showPrice: null,
                    isLoading: false,
                    orderBy: {
                        property: "price",
                        type: "asc"
                    }
                },
                filters: {
                    roomTypes: [],
                    price: {
                        minimum: null,
                        maximum: null
                    },
                    readinesses: [],
                    square: {
                        minimum: null,
                        maximum: null
                    },
                    squareKitchen: {
                        minimum: null,
                        maximum: null
                    },
                    floor: {
                        minimum: null,
                        maximum: null
                    },
                    facing: null
                },
                sums: {
                    apartmentsCount: 0,
                    apartmentsTypesCount: 0                   
                }
            }

        },
        computed: {
            formatedFilters() {
                return cleanObject({
                    roomTypes: this.filters.roomTypes,
                    price: this.filters.price,
                    readinesses: this.filters.readinesses,
                    square: this.filters.square,
                    squareKitchen: this.filters.squareKitchen,
                    floor: this.filters.floor,
                    facing: this.filters.facing
                });  
            },
            query() {
                return {
                    roomTypes: this.filters.roomTypes,
                    price: this.filters.price,
                    readinesses: this.filters.readinesses,
                    square: this.filters.square,
                    squareKitchen: this.filters.squareKitchen,
                    floor: this.filters.floor,
                    facing: this.filters.facing == 'Любая' ? null : this.filters.facing
                }            
            }
        },
        methods: {
            getData(page = 0) {
                this.apartments.isLoading = true;
                axios.post("/umbraco/Surface/Apartments/GetApartments", {                  
                    parent: this.parent,
                    size: this.size,
                    page: page,
                    orderBy: this.apartments.orderBy,
                    filters: this.formatedFilters,
                    landingId: this.parentLandingid
                }).then((response) => {
                    this.apartments.list = response.data.Items;
                    this.apartments.total = response.data.Total;
                    this.apartments.page = page;
                    this.sums.apartmentsCount = response.data.OtherProps['apartmentsCount'];
                    this.sums.apartmentsTypesCount = response.data.OtherProps['apartmentsTypesCount'];
                    this.apartments.isLoading = false;
                });
            },
            getNextPage() {
                this.apartments.isLoading = true;
                axios.post("/umbraco/Surface/Apartments/GetApartments", {                  
                    parent: this.parent,
                    size: this.size,
                    page: this.apartments.page + 1,
                    orderBy: this.apartments.orderBy,
                    filters: this.formatedFilters,
                    landingId: this.parentLandingid
                }).then((response) => {
                    this.apartments.list.push(...response.data.Items);
                    this.apartments.total = response.data.Total;
                    this.apartments.page++;
                    this.sums.apartmentsCount = response.data.OtherProps['apartmentsCount'];
                    this.sums.apartmentsTypesCount = response.data.OtherProps['apartmentsTypesCount'];
                    this.apartments.isLoading = false;
                });
            },
            getDataPages(count = 1) {
                this.apartments.isLoading = true;
                axios.post("/umbraco/Surface/Apartments/GetApartmentsPages", {                  
                    parent: this.parent,
                    size: this.size,
                    pages: count,
                    orderBy: this.apartments.orderBy,
                    filters: this.formatedFilters
                }).then((response) => {
                    this.apartments.list = response.data.Items;
                    this.apartments.total = response.data.Total;
                    this.sums.apartmentsCount = response.data.OtherProps['apartmentsCount'];
                    this.sums.apartmentsTypesCount = response.data.OtherProps['apartmentsTypesCount'];
                    this.apartments.isLoading = false;
                });
            },
            onOrderByChanged(newOrderBy) {
                this.apartments.orderBy = newOrderBy;
            },
            onSubmit() {
                this.$router.replace({ query: this.query })
                    .catch(() => {
                        // Just for navigation duplication error preventing
                    });
                axios.post("/umbraco/Surface/Apartments/GetApartments", {                  
                    parent: this.parent,
                    size: this.size,
                    page: 0,
                    orderBy: this.apartments.orderBy,
                    filters: this.formatedFilters,
                    landingId: this.parentLandingid
                }).then((response) => {
                    this.apartments.list = response.data.Items;
                    this.apartments.total = response.data.Total;
                    this.apartments.page = 0;
                    this.sums.apartmentsCount = response.data.OtherProps['apartmentsCount'];
                    this.sums.apartmentsTypesCount = response.data.OtherProps['apartmentsTypesCount'];
                });
            },
            onReset() {              
                this.filters.roomTypes.splice(0);
                this.filters.price = { minimum: null, maximum: null };
                this.filters.readinesses.splice(0);
                this.filters.square = { minimum: null, maximum: null };
                this.filters.squareKitchen = { minimum: null, maximum: null };
                this.filters.floor = { minimum: null, maximum: null };
                this.filters.facing = null;
                this.$router.replace({ query: this.query })
                    .catch(() => {
                        // Just for navigation duplication error preventing
                    });
                this.getData(0);
            },
            parseQueryString() {
                let query = this.$router.currentRoute.query;
                let keys = Object.keys(query);
                if (keys.length) {

                    if (keys.includes('roomTypes')) {
                        this.filters.roomTypes.push(...query.roomTypes);
                    }

                    if (keys.includes('price')) {
                        this.filters.price = query.price;
                    }

                    if (keys.includes('readinesses')) {
                        this.filters.readinesses.push(...query.readinesses.map(x => Number(x)));
                    }

                    if (keys.includes('square')) {
                        this.filters.square = query.square;
                    }

                    if (keys.includes('squareKitchen')) {
                        this.filters.squareKitchen = query.squareKitchen;
                    }

                    if (keys.includes('floor')) {
                        this.filters.floor = query.floor;
                    }

                    if (keys.includes('facing')) {
                        this.filters.facing = query.facing;
                    }
                }
            },
            planUrl(path) {
                return path != '#' && path ? path : "/images/empty-plan.png"
            }
        },
        watch: {
            'apartments.orderBy': {
                handler() {
                    this.getDataPages(this.apartments.page + 1);
                },
                deep: true
            }
        },
        created() {
            this.parseQueryString();
            this.getData(0);
        },
        filters: {
            threeDigits,
            roomsCount,
            apartmentsCount,
            typesCount
        },
        components: {
            apartmentsOrderButton,
            apartmentsFilters
        },
        router: new VueRouter({
            mode: "history",
            parseQuery(query) {
                return qs.parse(query);
            },
            stringifyQuery(query) {
                let result = qs.stringify(cleanObject(query), {
                    skipNulls: true
                });
                return result ? ('?' + result) : '';
            }
        })
    }
</script>